// Secondary top bar configurations using translation keys for reactive updates

export const overviewSecondaryTopBar = [
  {
    labelKey: 'secondary.monthlyOverview',
    path: '/',
  },
  {
    labelKey: 'secondary.dailyOverview',
    path: '/day',
  }
];

export const tableSecondaryTopBar = [
  {
    labelKey: 'secondary.edit',
    path: '/table',
  },
  {
    labelKey: 'secondary.list',
    path: '/table/table-list'
  }
];

export const settingsSecondaryTopBar = [
  {
    labelKey: 'secondary.reservations',
    path: '/settings',
  },
  {
    labelKey: 'secondary.email',
    path: '/settings/email',
  },
  {
    labelKey: 'secondary.pdfMenu',
    path: '/settings/pdf-menu',
  },
  {
    labelKey: 'secondary.fields',
    path: '/settings/fields',
  },
];

export const calendarSecondaryTopBar = [
  {
    labelKey: 'secondary.openingHours',
    path: '/scheme',
  },
  {
    labelKey: 'secondary.calendar',
    path: '/scheme/calendar',
  },
];

export const openinghoursSecondaryTopBar = [
  {
    labelKey: 'secondary.breakfast',
    path: '/openinghours',
  },
  {
    labelKey: 'secondary.lunch',
    path: '/openinghours/lunch',
  },
  {
    labelKey: 'secondary.dinner',
    path: '/openinghours/dinner',
  },
];

export const designSecondaryTopBar = [
  {
    labelKey: 'secondary.manage',
    path: '/settings',
  },
  {
    labelKey: 'secondary.design',
    path: '/settings/design',
  },
  {
    labelKey: 'secondary.preview',
    path: '/settings/launch',
  },
];

export const accountSecondaryTopBar = [];

export const giftCardSecondaryTopBar = [
  {
    labelKey: 'secondary.overview',
    path: '/giftcard/',
  },
  {
    labelKey: 'secondary.design',
    path: '/giftcardEditor',
  },
  {
    labelKey: 'secondary.settings',
    path: '/giftcardSettings',
  },
];

export const maxArrivalsSecondaryTopBar = [
  {
    labelKey: 'secondary.breakfast',
    path: '/max-arrivals',
  },
  {
    labelKey: 'secondary.lunch',
    path: '/max-arrivals/lunch',
  },
  {
    labelKey: 'secondary.dinner',
    path: '/max-arrivals/dinner',
  },
];

export const emailSecondaryTopBar = [
  {
    labelKey: 'secondary.confirmationEmail',
    path: '/email',
  },
  {
    labelKey: 'secondary.reminderEmail',
    path: '/email/reminder',
  },
];

export const maxGroupsSecondaryTopBar = [
  {
    labelKey: 'secondary.breakfast',
    path: '/max-groups',
  },
  {
    labelKey: 'secondary.lunch',
    path: '/max-groups/lunch',
  },
  {
    labelKey: 'secondary.dinner',
    path: '/max-groups/dinner',
  },
];

export const inboxSecondaryTopBar = [
  {
    labelKey: 'secondary.inbox',
    path: '/inbox',
  },
  {
    labelKey: 'secondary.inboxSettings',
    path: '/inbox/settings',
  },
];
